export interface Rotor {
  curveType: string;
  text: string;
}
